import { difficultyToColourClass } from './utils';
import type { DifficultyVariant } from './constants';

const LEGEND_ORDER: DifficultyVariant[] = [
  'very-easy',
  'easy',
  'moderate',
  'hard',
  'very-hard'
];

const labelClassName =
  'font-open-sans text-[11px] font-semibold uppercase tracking-wide text-neutral-500';

export const DifficultyLegend = () => (
  <div className="flex items-center gap-2" data-testid="difficulty-legend">
    <span className={labelClassName}>Easier</span>
    <div aria-hidden="true" className="flex gap-[3px]">
      {LEGEND_ORDER.map((variant) => (
        <span
          key={variant}
          className={`h-2 w-4 rounded-sm ${difficultyToColourClass(variant)}`}
        />
      ))}
    </div>
    <span className={labelClassName}>Harder</span>
  </div>
);
